import { setupListeners } from '@reduxjs/toolkit/query'
import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './reducers/auth';
import catalogReducer from './reducers/catalog';
import menuReducer from './reducers/menu';
import cartReducer from './reducers/cart';
import subsiteReducer from './reducers/subsite';
import userReducer from './reducers/users';
import orderReducer from './reducers/orders';
import poReducer from './reducers/purchaseorder';
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
  key: 'root',
  storage: storage,
  blacklist: ['orders', 'catalog', 'subsite', 'purchaseorders', 'menu', 'users']

};
export const rootReducers = combineReducers({
  auth: authReducer,
  catalog: catalogReducer,
  menu: menuReducer,
  cart: cartReducer,
  subsite: subsiteReducer,
  users: userReducer,
  orders: orderReducer,
  purchaseorders: poReducer
});
const persistedReducer = persistReducer(persistConfig, rootReducers);
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});
setupListeners(store.dispatch);
export default store;